/**
 * SchemeDiversity.jsx  — Page shell only
 * Handles: session restore, Redux sync, header, title bar
 * All content delegated to SchemeDiversityView
 */

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch }   from 'react-redux';
import { Navigate }                   from 'react-router-dom';

import KPIHeader                from '../../Header/KPIHeader';
import KPISubHeader             from '../../Header/SubHeader/KPISubHeader';
import SchemeDiversityDefitions from '../../Defintions/SchemeDiversityDefitions';
import SchemeDiversityView from '../../KPI/Scheme Diversity/SchemeDiversityView';

import { getSession }                           from '../../utils/session';
import { setProjectDetails, setProjectsData, setEmail as setReduxEmail } from '../../userSlice';

const SchemeDiversity = () => {
  const dispatch = useDispatch();

  const reduxEmail       = useSelector(s => s.user.email);
  const reduxProjectName = useSelector(s => s.user.projectName);
  const reduxPid         = useSelector(s => s.user.projectId);
  const reduxViewIds     = useSelector(s => s.user.viewIds);
  const isSuperuser      = useSelector(s => s.user.isSuperuser);

  const [email,       setEmail]       = useState(reduxEmail       || '');
  const [projectName, setProjectName] = useState(reduxProjectName || '');
  const [pid,         setPid]         = useState(reduxPid         || '');
  const [viewIds,     setViewIds]     = useState(reduxViewIds     || []);
  const [loading,     setLoading]     = useState(true);

  useEffect(() => {
    // If Redux already has data (normal SPA navigation) — use it directly
    if (reduxEmail && reduxPid) {
      setEmail(reduxEmail);
      setPid(reduxPid);
      setProjectName(reduxProjectName || '');
      setViewIds(reduxViewIds || []);
      setLoading(false);
      return;
    }

    // Hard refresh / direct URL — restore from sessionStorage
    const session = getSession();
    if (session?.email) {
      setEmail(session.email);
      setPid(session.projectId    || '');
      setProjectName(session.projectName || '');
      setViewIds(session.viewIds  || []);

      dispatch(setProjectDetails({
        email:            session.email,
        projectName:      session.projectName,
        projectId:        session.projectId,
        organizationName: session.organizationName,
      }));

      if (session.projectsData && reduxViewIds.length === 0) {
        dispatch(setReduxEmail(session.email));
        dispatch(setProjectsData(session.projectsData));
      }
    }
    setLoading(false);
  }, [dispatch, reduxEmail, reduxPid, reduxProjectName, reduxViewIds]);

  // Keep local state in sync when user switches project
  useEffect(() => {
    if (reduxPid)             setPid(reduxPid);
    if (reduxViewIds?.length) setViewIds(reduxViewIds);
    if (reduxProjectName)     setProjectName(reduxProjectName);
  }, [reduxPid, reduxViewIds, reduxProjectName]);

  if (loading) return null;
  if (!email)  return <Navigate to="/" replace />;

  return (
    <div className="bg-gray-50 min-h-screen">
      <KPIHeader />
      <KPISubHeader />
      <div className="mt-32">
        

        {/* Project title bar */}
        

        {/* All gated content lives here */}
        <SchemeDiversityView pid={pid} viewIds={viewIds} isSuperuser={isSuperuser} />
      </div>
    </div>
  );
};

export default SchemeDiversity;